import { c as _c } from "react/compiler-runtime";
import { selectLocationPath } from "@store/markups/markups-selector-utils";
import { Breadcrumbs, LocationPinIcon, NO_TRANSLATE_CLASS, Skeleton } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { useAppSelector } from "@store/store-helper";
import { AnnotationSidePanelEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { OPEN_PROJECT_TARGET_ATTRIBUTE } from "@utils/project-utils";
/** Whether both paths hold the same places, so the selector does not render again for a copy */
function isSamePath(path1, path2) {
  return path1.length === path2.length && path1.every(({
    id
  }, index) => id === path2[index].id);
}

/**
 * Where the annotation is, as breadcrumbs from the outermost place, e.g. the area, to its scan or
 * scene, each opening the Sphere Viewer there
 */
export function MarkupSidePanelLocation(t0) {
  const $ = _c(12);
  const {
    markup,
    isLoading,
    placeId
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  let t1;
  if ($[0] !== markup || $[1] !== placeId) {
    t1 = state => {
      const placePath = placeId ? selectLocationPath(placeId, markup.id)(state) : [];
      return placePath.length ? placePath : selectLocationPath(markup.id, markup.id)(state);
    };
    $[0] = markup;
    $[1] = placeId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const path = useAppSelector(t1, isSamePath);
  if (!path.length && !isLoading) {
    return null;
  }
  let t2;
  if ($[3] !== path || $[4] !== trackEvent) {
    t2 = function onBreadcrumbClick(breadcrumb) {
      trackEvent({
        name: AnnotationSidePanelEvents.openLocationInViewer,
        props: {
          depth: path.findIndex(t3 => {
            const {
              sphereViewerUrl
            } = t3;
            return sphereViewerUrl === breadcrumb.link;
          }),
          totalDepth: path.length
        }
      });
      if (breadcrumb.link) {
        window.open(breadcrumb.link, OPEN_PROJECT_TARGET_ATTRIBUTE);
      }
    };
    $[3] = path;
    $[4] = trackEvent;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onBreadcrumbClick = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      alignItems: "center",
      gap: 0.5,
      minWidth: 0,
      "& .MuiBreadcrumbs-root": {
        overflow: "visible",
        minWidth: 0
      },
      "& .MuiBreadcrumbs-root .MuiBreadcrumbs-ol": {
        flexWrap: "wrap",
        width: "auto",
        rowGap: 0.5
      }
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <LocationPinIcon sx={{
      width: "1rem",
      height: "1rem",
      color: "text.secondary"
    }} />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isLoading || $[9] !== onBreadcrumbClick || $[10] !== path) {
    t5 = <Stack direction="row" data-testid="markup-side-panel-location" className={NO_TRANSLATE_CLASS} sx={t3}>{t4}{isLoading ? <Skeleton variant="text" sx={{
        width: "12rem",
        fontSize: "0.875rem"
      }} /> : <Breadcrumbs breadcrumbs={path.map(_temp)} onBreadcrumbClick={onBreadcrumbClick} shouldLinkLastItem={true} maxWidth="14rem" maxWidthMd="10rem" maxWidthSm="7rem" />}</Stack>;
    $[8] = isLoading;
    $[9] = onBreadcrumbClick;
    $[10] = path;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp(t0) {
  const {
    name,
    sphereViewerUrl: sphereViewerUrl_0
  } = t0;
  return {
    text: name,
    link: sphereViewerUrl_0,
    shouldNotTranslate: true,
    showTooltip: true
  };
}